import u from 'umbrellajs'
import Cookies from 'js-cookie'

export default function FeatureBar(){
  const $bar = u('.feature-bar')
  const hasDismissed = Cookies.get('FeatureBarDismissed')

  if(hasDismissed){
    $bar.addClass('hidden')
  }

  $bar.find('.close').on('click', function(){
    $bar.addClass('hidden')
    Cookies.set('FeatureBarDismissed', true)
  })
  return () => {}
}
